import { SentryService } from '@rd-lib/sentry/sentry.service';
import { LoyaltyCurrency } from './loyalty-currency.type';
import {
  LoyaltyProgramCapabilities,
  LoyaltyProgramCapability,
} from './loyalty-program-capability.type';
import { RewardsProgram } from './rewards_program.type';
import { TransferRate } from './transfer-rate.type';

export enum LoyaltyProgramCategory {
  Airline = 'airline',
  Hotel = 'hotel',
  CashbackToCard = 'cashback_to_card',
  CashbackToAccount = 'cashback_to_account',
  CashbackToPlatform = 'cashback_to_platform',
  StatusUpgrade = 'status_upgrade',
  Voucher = 'voucher',
  Others = 'others',
  Retail = 'retail',
}

export function getCapability(
  capabilities: LoyaltyProgramCapability[],
  type: LoyaltyProgramCapabilities,
  sentryService: SentryService,
): LoyaltyProgramCapability {
  if (!capabilities || capabilities.length === 0) {
    sentryService.manualError('Loyalty Program capabilities cannot be found');
    return {} as LoyaltyProgramCapability;
  }

  // In case if we mistakenly send in the wrong category type to filter the capability
  // Or if the given category cannot be found, we default it to the first capability
  // To gracefully handle this issue
  return (
    capabilities.find((capability) => capability.category === type) || {
      id: capabilities[0].id,
      detailsUrl: capabilities[0].detailsUrl,
      logoUrl: capabilities[0].logoUrl,
      conditionsUrl: capabilities[0].conditionsUrl,
      enrollmentUrl: capabilities[0].enrollmentUrl,
      category: capabilities[0].category,
      processingDelay: capabilities[0].processingDelay,
    }
  );
}

export class LoyaltyProgram {
  id: string;
  category: LoyaltyProgramCategory;
  name: string;
  shortName: string;
  description?: string;
  loyaltyCurrency?: LoyaltyCurrency;
  transferConnectIdentifier: string;
  manualVerificationRequired: boolean;
  rewardsProgram?: Omit<RewardsProgram, 'loyaltyProgram' | 'loyaltyProgramId'>;
  capabilities: LoyaltyProgramCapability[];
  transferRate: TransferRate;
  sortIndex: number;
  pointsTransferCapability: LoyaltyProgramCapability;
  benefitCapability: LoyaltyProgramCapability;
  cashBackToCardCapability: LoyaltyProgramCapability;
  cashBackToAccountCapability: LoyaltyProgramCapability;
  cashBackToPlatformCapability: LoyaltyProgramCapability;
}
